import { http } from 'vue'

export default {
  postCertificate (context, params) {
    switch (params.data.type) {
      case 'cert_debt_absence_by_state':
        return http.post('cert_debt_absence_by_state', params.data)
      case 'pc_antecedentes':
        return http.post('pc_antecedente_by_state_person', params.data)
      case 'pf_antecedentes':
        return http.post('pf_antecedente_person', params.data)
      case 'fgts':
        return http.post('fgts', params.data)
      case 'pgfn':
        return http.post('pgfn', params.data)
      default:
        return http.post('all_certificates', params.data)
    }
  },
  loadCertificates (context, params = {}) {
    return http.get('certificates?client_id=' + params.client_id)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/certificates/actions.js